<template>
    <v-container>
        <v-card-title>
            <CreateModal :id="id" @created="crear"></CreateModal>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                :headers="headers"
                :items="direcciones.data"
                :search="search"
                :pagination.sync="pagination"
                hide-actions
                :loading="loading"
                :total-items="8"
                v-on:update:pagination="ordenar"
        >
            <template slot="items" slot-scope="props">
                <td>{{ props.item.company_name }}</td>
                <td>{{ props.item.billing_data }}</td>
                <td class="text-xs">{{ props.item.country.name }}</td>
                <td>{{ props.item.vat }}</td>
                <td class="text-xs">
                    <v-btn flat icon color="primary" v-if="props.item.default" @click="setDefault(props.item.id)">
                        <v-icon>star</v-icon>
                    </v-btn>
                    <v-btn flat icon color="primary" v-if="! props.item.default" @click="setDefault(props.item.id)">
                        <v-icon>star_border</v-icon>
                    </v-btn>
                </td>
                <td class="layout px-0 align-center">
                    <v-menu
                            transition="slide-y-transition"
                            bottom
                            left
                    >
                        <v-btn
                                slot="activator"
                                color="primary"
                                dark
                                fab
                                flat
                        >
                            <v-icon>settings</v-icon>
                        </v-btn>
                        <v-list>
                            <v-list-tile>
                                <v-btn flat block v-on:click="deleteDireccion(props.item.id)"><v-icon left>mdi-delete-circle</v-icon>Delete</v-btn>
                            </v-list-tile>
                            <v-list-tile>
                                <EditModal :id="id" :direccion="props.item" v-on:editado="updateDireccion"></EditModal>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </td>
            </template>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>
        </v-data-table>
        <div class="text-xs-center pt-4 pb-4" v-if="direcciones.data">
            <v-pagination
                    @input="setPage"
                    v-model="page"
                    :length="last_page"
                    color="secondary"
                    circle
                    :total-visible="7"
            ></v-pagination>
            <p class="subtitle">Showing {{ direcciones.meta.from }} to {{ direcciones.meta.to }} of {{ direcciones.meta.total }} entries</p>
        </div>
    </v-container>
</template>

<script>

    import CreateModal from '../components/CreateDireccionFacturacionModalComponent';
    import EditModal from '../components/EditDireccionFacturacionModalComponent';

    export default {
        props: ['id'],
        data () {
            return {
                dialog: false,
                direcciones: [],
                search: '',
                headers: [
                    {
                        text: 'Company name',
                        align: 'left',
                        sortable: true,
                        value: 'company_name'
                    },
                    {
                        text: 'Billing data',
                        sortable: true,
                        value: 'billing_data'
                    },
                    { text: 'Country', value: 'country_id' },
                    { text: 'Vat', value: 'vat' },
                    { text: 'Default', value: 'default' },
                    { text: 'Actions', value: 'action', sortable: false }
                ],
                page: null,
                last_page: null,
                pagination: {},
                loading: true,
                fab: [],
                fling: false,
                hover: false,
                tabs: null,
                top: false,
                right: true,
                bottom: true,
                left: false,
                transition: 'slide-x-transition',
                direction: 'left',
                sortBy: 'billing_data',
                order: 'asc',
            }
        },
        created () {
            this.getDirecciones();
            this.debouncedGetDirecciones = _.debounce(this.getDirecciones, 500)
        },
        watch: {
            search: function () {
                this.loading = true;
                this.debouncedGetDirecciones();
            },
            last_page: function () {
                if (this.page > this.direcciones.meta.last_page) {
                    this.page = 1;
                }
            }
        },
        methods : {
            ordenar (payload) {
                this.sortBy = payload.sortBy;
                if (payload.descending) {
                    this.order = 'desc';
                } else {
                    this.order = 'asc';
                }
                this.getDirecciones();
            },
            setPage (page) {
                this.page = page;
                this.getDirecciones();
            },
            getDirecciones () {
                var params = {
                    filters : {
                        search: this.search,
                        page: this.page,
                        sortBy: this.sortBy,
                        order: this.order
                    },
                    client_id: this.id
                };

                this.$store.dispatch('getClientDireccionesFacturacion', params).then((res) => {

                    this.direcciones = res.data;
                    this.page = res.data.meta.current_page;
                    this.last_page = res.data.meta.last_page;
                    this.loading = false;

                    this.fab = [];

                    for (var i = 0; i < res.data.data.length; i++) {
                        this.fab.push(false);
                    }

                }).catch((error) => {

                });
            },
            deleteDireccion (id) {
                this.$confirm('Do you really want to delete?').then(res => {
                    if (res == true) {
                        this.$store.dispatch('deleteClientDireccionesFacturacion', {
                            cliente_id: this.id,
                            direccion_id: id
                        }).then((res) => {
                            this.getDirecciones();
                        }).catch((error) => {

                        });
                    }
                })
            },
            crear (direccion) {
                this.$store.dispatch('createClientDireccionesFacturacion', direccion).then((res) => {
                    this.getDirecciones();
                }).catch((error) => {

                });
            },
            updateDireccion (contact) {
                this.$store.dispatch('updateClientDireccionesFacturacion', contact).then((res) => {
                    this.getDirecciones();
                }).catch((error) => {

                });
            },
            setDefault (id) {
                this.$store.dispatch('setDefaultDireccionFacturacion', {
                    cliente_id: this.id,
                    id: id
                }).then((res) => {
                    this.getDirecciones();
                }).catch((error) => {

                });
            }
        },
        components: {
            CreateModal,
            EditModal
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/clients/view/DireccionesComponent.vue